import { Pill } from "../../components/Pill";
import {
  DISCREPANCY_SEVERITY_UI,
  DISCREPANCY_STATUS_UI,
  DISCREPANCY_TYPE_UI,
} from "../../lib/enumUI";
import type { Discrepancy } from "../types";

export function DiscrepancyList({ items }: { items: Discrepancy[] }) {
  if (items.length === 0) {
    return (
      <section>
        <h2>Discrepancies</h2>
        <p className="empty-state">No discrepancies for this project.</p>
      </section>
    );
  }

  return (
    <section>
      <h2>Discrepancies</h2>
      <table className="data-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Status</th>
            <th>Severity</th>
            <th>Opened</th>
            <th>Closed</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {items.map((d) => (
            <DiscrepancyRow key={d.id} discrepancy={d} />
          ))}
        </tbody>
      </table>
    </section>
  );
}

function DiscrepancyRow({ discrepancy }: { discrepancy: Discrepancy }) {
  return (
    <tr>
      <td>{DISCREPANCY_TYPE_UI[discrepancy.discrepancy_type].label}</td>
      <td>
        <Pill tone={DISCREPANCY_STATUS_UI[discrepancy.status].tone}>
          {DISCREPANCY_STATUS_UI[discrepancy.status].label}
        </Pill>
      </td>
      <td>
        <Pill tone={DISCREPANCY_SEVERITY_UI[discrepancy.severity].tone}>
          {DISCREPANCY_SEVERITY_UI[discrepancy.severity].label}
        </Pill>
      </td>
      <td>{new Date(discrepancy.opened_at).toLocaleString()}</td>
      <td>
        {discrepancy.closed_at
          ? new Date(discrepancy.closed_at).toLocaleString()
          : "—"}
      </td>
      <td>
        <DetailsBlock details={discrepancy.details_json} />
      </td>
    </tr>
  );
}

function DetailsBlock({ details }: { details: Record<string, unknown> }) {
  const entries = Object.entries(details);
  if (entries.length === 0) return <span>—</span>;
  return (
    <dl className="inline-dl">
      {entries.map(([key, value]) => (
        <div key={key}>
          <dt>{key}</dt>
          <dd>{value === null ? "—" : String(value)}</dd>
        </div>
      ))}
    </dl>
  );
}
